import React from 'react';

interface DesktopMockupProps {
  children: React.ReactNode;
}

export const DesktopMockup: React.FC<DesktopMockupProps> = ({ children }) => {
  return (
    <div className="w-full max-w-4xl bg-white rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] border border-slate-200/60 overflow-hidden flex flex-col">
      {/* Browser Header */}
      <div className="h-10 bg-[#f0f0f0] border-b border-slate-300 flex items-center px-3 space-x-3">
        <div className="flex-1 flex items-center">
          <div className="h-7 bg-white rounded border border-slate-300 flex items-center px-3 flex-1 max-w-md">
            <span className="text-[11px] text-slate-500">medrec.commure</span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 flex items-center justify-center text-slate-500 hover:bg-slate-200 cursor-pointer text-[10px]">&#8212;</div>
          <div className="w-4 h-4 flex items-center justify-center text-slate-500 hover:bg-slate-200 cursor-pointer text-[10px]">&#9633;</div>
          <div className="w-4 h-4 flex items-center justify-center text-slate-500 hover:bg-red-500 hover:text-white cursor-pointer text-[10px]">&#10005;</div>
        </div>
      </div>
      
      {/* Browser Content */}
      <div className="flex-1 overflow-auto bg-slate-50 relative h-[800px]">
        {children}
      </div>
    </div>
  );
};

